import React from 'react';
import StickyNav from './StickyNav';
import AssessmentPromoBar from './AssessmentPromoBar';
import { Toaster } from '@/components/ui/sonner';
import Footer from '@/components/Footer';
import ChatbotLabel from '@/components/ChatbotLabel';
import AskDDLoader from '@/components/AskDDLoader';
import HubSpotLoader from '@/components/HubSpotLoader';
import GtmRouteTracker from '@/components/GtmRouteTracker';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-background font-body flex flex-col">
      {/* Per-page <Helmet> tags are managed via HelmetProvider (mounted in index.js, outside StrictMode). */}

      {/* Skip to Content Link for Accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 z-[100] bg-primary text-white px-6 py-3 font-heading font-bold border-2 border-black rounded-brutal shadow-block"
      >
        Skip to Content
      </a>

      <AssessmentPromoBar />
      <StickyNav />

      <main id="main-content" className="flex-1 flex flex-col">
        {children}
      </main>

      <Toaster />

      {/* Chatbot Label - Points to AskDD widget */}
      <ChatbotLabel />

      {/* AskDD widget loader — independent of the label so dismissing
          the "TEST OUR AGENT" hint never blocks the chatbot script. */}
      <AskDDLoader />

      {/* HubSpot tracking loader — lazy-injected, with SPA route-change
          page-view tracking via useLocation. */}
      <HubSpotLoader />

      {/* GTM: dataLayer page_view on every route change (container snippet lives in public/index.html) */}
      <GtmRouteTracker />

      <Footer />
    </div>
  );
}
